<template>
  <v-alert color="info" dense="" text="" class="" outlined="" v-if="!value">
    <div class="d-flex flex-wrap">
      <v-icon color="blue" class="mr-2">mdi-rocket</v-icon>
      <div class="mt-auto mb-auto">
        Ready to start enrolling groups of users? Upgrade to the Growth Plan to
        get started.
      </div>
      <v-spacer />
      <v-btn
        v-if="
          permissions.includes('admin') || permissions.includes('super admin')
        "
        class="mt-auto mb-auto"
        small=""
        rounded=""
        depressed=""
        color="blue"
        dark=""
        :to="{ name: 'billing-account' }"
        >Upgrade</v-btn
      >
    </div>
  </v-alert>
</template>

<script>
import services from "@/services";
export default {
  props: ["value"],
  computed: {
    permissions() {
      if (Array.isArray(this.$store.getters.getUser.permissions)) {
        return this.$store.getters.getUser.permissions;
      } else {
        return [];
      }
    }
  },

  methods: {
    async isEnterprise() {
      // const { account } = await services.billing.accounts.getDetails();
      return true;
      // account && account.metadata
      //   ? account.metadata.locked === "true"
      //     ? true
      //     : false
      //   : false;
    },
    async fetchLabels() {
      /**
       * @type {Array<Object>}
       */
      const subs = await services.billing.subscriptions.get();
      const details = [];
      subs.forEach(sub => {
        details.push(
          services.billing.subscriptions.getByID({ subscription: sub.id })
        );
      });
      const items = await Promise.all(details);
      const labels = [];
      items.forEach(sub => {
        /**
         * @type {Array}
         */
        const items = sub.items;
        if (!items || !Array.isArray(items)) {
          return;
        }
        items.forEach(item => {
          console.log(item);
          if (
            item &&
            item.price &&
            item.price.product &&
            item.price.product.metadata &&
            item.price.product.metadata.label
          ) {
            labels.push(item.price.product.metadata.label);
          }
        });
      });

      return labels;
    }
  },
  async mounted() {
    this.$emit("input", true);
    try {
      const labels = await this.fetchLabels();
      if (await this.isEnterprise()) {
        return this.$emit("input", true);
      }
      if (!labels.includes("growth")) {
        this.$emit("input", false);
      } else {
        this.$emit("input", true);
      }
    } catch (err) {
      this.$emit("input", false);
    }
  }
};
</script>

<style></style>
